import humps from 'humps'
import Api from '@/api'
const resource = 'portfolio_builder'

export default {
  fetchPortfolioBuilder (query) {
    return Api.get(`/${resource}/portfolio_templates`, { params: humps.decamelizeKeys(query) })
  },

  createPortfolioBuilder (payload) {
    return Api.post(`/${resource}/portfolio_templates`, { ...payload })
  },

  updatePortfolioBuilder (portfolioId, payload) {
    return Api.put(`/${resource}/portfolio_templates/${portfolioId}`, { ...payload })
  },

  deleteModelPortfolioById(modelPortfolioId) {
    return Api.delete(`/${resource}/portfolio_templates/${modelPortfolioId}`)
  },

  fetchProductsPortfolioBuilder (filters, page) {
    return Api.get(`/contracts`, { params: humps.decamelizeKeys({ ...filters, page }) })
  },

  fetchProductPortfolioBuilder (productId, advisorDetails) {
    return Api.get(`/contracts/${productId}`, { params: humps.decamelizeKeys({ advisorDetails }) })
  },

  downloadModelPortfolioPdf (modelPortfolioId) {
    return Api.get(`/portfolio_builder/portfolio_templates/${modelPortfolioId}/pdf`, { responseType: 'blob' })
  },
}
